<template>
    <v-container class="pa-5" fluid>
        <ConfirmDialog
            :is-open="confirmRemoveCustomerContactDialog"
            :data="currentCustomerContact"
            @on-confirm="removeCustomerContact"
            @on-abort="closeConfirmRemoveCustomerContactDialog"
        >
            <template #title>
                Usuwanie kontaktu
            </template>
            <template #content>
                Czy na pewno chcesz usunąć kontakt?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>

        <ConfirmDialog
            :is-open="confirmRemoveCustomerAddressDialog"
            :data="currentCustomerAddress"
            @on-confirm="removeCustomerAddress"
            @on-abort="closeConfirmRemoveCustomerAddressDialog"
        >
            <template #title>
                Usuwanie adresu
            </template>
            <template #content>
                Czy na pewno chcesz usunąć adres?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>

        <CustomerContactDialog
            :is-open="customerContactDialog"
            :customer-contact-data="currentCustomerContact"
            :customer-data="customer"
            @on-confirm="saveCustomerContact"
            @on-close="closeCustomerContactDialog"
        />

        <CustomerAddressDialog
            :is-open="customerAddressDialog"
            :customer-address-data="currentCustomerAddress"
            :customer-contact-data="currentCustomerContact"
            :customer-data="customer"
            @on-confirm="saveCustomerAddress"
            @on-close="closeCustomerAddressDialog"
        />

        <page-title>
            {{ pageTitle }}
        </page-title>

        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="onClose"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="8" offset-xl="2">
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-toolbar flat dense color="white lighten-2">
                                                <v-toolbar-title>Dane klienta</v-toolbar-title>
                                            </v-toolbar>
                                            <v-divider />
                                            <v-card-text>
                                                <v-container class="py-0 mt-1">
                                                    <v-row>
                                                        <v-col cols="12" sm="4">
                                                            <v-text-field
                                                                v-model="customer.name"
                                                                label="Nazwa firmy"
                                                                item-value="name"
                                                                :error-messages="nameErrors"
                                                                outlined
                                                                dense
                                                                required
                                                                @input="changeCustomerName"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="4">
                                                            <v-text-field
                                                                v-model="customer.nip"
                                                                v-mask="'############'"
                                                                label="Nip"
                                                                item-value="name"
                                                                outlined
                                                                dense
                                                                :error-messages="nipErrors"
                                                                required
                                                                @input="changeCustomerNip"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" sm="4">
                                                            <v-select
                                                                v-model="customer.customerTypeId"
                                                                :items="customerTypes"
                                                                item-value="id"
                                                                no-data-text="Nie znaleziono typu klienta"
                                                                label="Typ klienta"
                                                                outlined
                                                                dense
                                                                required
                                                                :error-messages="customerTypeIdErrors"
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>

                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>
                                                            </v-select>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12" sm="6" md="4">
                                                            <v-switch
                                                                v-model="isActive"
                                                                label="Czy aktywny?"
                                                                class=" mt-1"
                                                                @change="changeActive"
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                        <v-col cols="auto">
                            <h2 class="text-h6">
                                Adresy
                            </h2>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                color="secondary"
                                fab
                                small
                                class="elevation-1"
                                data-sentry-label="Dodaj adres"
                                @click="showCreateCustomerAddressDialog"
                            >
                                <v-icon>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="customer.customerAddresses.length === 0">
                        <v-col cols="12">
                            <v-alert
                                type="info"
                                text
                                border="left"
                            >
                                Brak adresów.
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels
                                v-model="openedCustomerAddressesPanels"
                                accordion
                                multiple
                            >
                                <v-expansion-panel v-for="(address, addressIndex) in customer.customerAddresses" :key="addressIndex">
                                    <v-expansion-panel-header>
                                        <v-row no-gutters align="center" dense>
                                            <v-col cols="auto">
                                                <span>
                                                    <h1 class="text-subtitle-1">
                                                        <template>
                                                            {{ parseAddress(address) }}
                                                        </template>
                                                    </h1>
                                                </span>
                                            </v-col>
                                            <v-col>
                                                <v-container fluid class="pa-0">
                                                    <v-row justify="end" dense>
                                                        <v-tooltip :open-delay="tooltipDelay" top>
                                                            <template #activator="{on}">
                                                                <v-btn
                                                                    icon
                                                                    v-on="on"
                                                                    @click.native="showEditCustomerAddressDialog($event, address)"
                                                                >
                                                                    <v-icon color="blue">
                                                                        mdi-pencil
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Edycja</span>
                                                        </v-tooltip>
                                                        <v-tooltip :open-delay="tooltipDelay" top>
                                                            <template #activator="{on}">
                                                                <v-btn
                                                                    icon
                                                                    data-sentry-label="Usuń komponent"
                                                                    v-on="on"
                                                                    @click="showConfirmRemoveCustomerAddressDialog($event, address)"
                                                                >
                                                                    <v-icon color="pink">
                                                                        mdi-delete
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Usuń Adres</span>
                                                        </v-tooltip>
                                                    </v-row>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-header>
                                    <v-divider />
                                    <v-expansion-panel-content>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-container>
                                                    <v-row align="center">
                                                        <v-col cols="auto">
                                                            <strong>Kontakty</strong>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <v-btn
                                                                color="secondary"
                                                                fab
                                                                x-small
                                                                class="elevation-1"
                                                                data-sentry-label="Dodaj Kontakt"
                                                                @click="showCreateCustomerContactDialog(addressIndex)"
                                                            >
                                                                <v-icon>
                                                                    mdi-plus
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                        <v-col v-if="address.contacts.length === 0" cols="12">
                                                            <v-alert
                                                                type="info"
                                                                text
                                                                border="left"
                                                            >
                                                                Brak kontaktów.
                                                            </v-alert>
                                                        </v-col>
                                                        <v-col v-else cols="12">
                                                            <v-expansion-panels
                                                                v-model="openedContactsPanels"
                                                                accordion
                                                                multiple
                                                            >
                                                                <v-expansion-panel v-for="(contact, contactIndex) in address.contacts" :key="contactIndex">
                                                                    <v-expansion-panel-header hide-actions>
                                                                        <v-row no-gutters align="right" dense>
                                                                            <v-col cols="auto">
                                                                                <span>
                                                                                    <h1 class="text-subtitle-1">
                                                                                        <template>
                                                                                            {{ parseContact(contact) }}
                                                                                        </template>
                                                                                    </h1>
                                                                                </span>
                                                                            </v-col>
                                                                            <v-col>
                                                                                <v-container fluid class="pa-0">
                                                                                    <v-row justify="end" dense>
                                                                                        <v-tooltip :open-delay="tooltipDelay" top>
                                                                                            <template #activator="{on}">
                                                                                                <v-btn
                                                                                                    icon
                                                                                                    data-sentry-label="Edycja kontaktu"
                                                                                                    v-on="on"
                                                                                                    @click.native="showEditCustomerContactDialog(contactIndex, addressIndex)"
                                                                                                >
                                                                                                    <v-icon color="blue">
                                                                                                        mdi-pencil
                                                                                                    </v-icon>
                                                                                                </v-btn>
                                                                                            </template>
                                                                                            <span>Edycja</span>
                                                                                        </v-tooltip>
                                                                                        <v-tooltip :open-delay="tooltipDelay" top>
                                                                                            <template #activator="{on}">
                                                                                                <v-btn
                                                                                                    icon
                                                                                                    data-sentry-label="Usuń kontakt"
                                                                                                    v-on="on"
                                                                                                    @click.native="showConfirmRemoveCustomerContactDialog(contactIndex, addressIndex)"
                                                                                                >
                                                                                                    <v-icon color="pink">
                                                                                                        mdi-delete
                                                                                                    </v-icon>
                                                                                                </v-btn>
                                                                                            </template>
                                                                                            <span>Usuń Adres</span>
                                                                                        </v-tooltip>
                                                                                    </v-row>
                                                                                </v-container>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-expansion-panel-header>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="8">
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-toolbar flat dense color="white lighten-2">
                                                <v-row align="center">
                                                    <v-col>
                                                        <v-toolbar-title>Billboardy</v-toolbar-title>
                                                        <v-spacer />
                                                    </v-col>
                                                    <v-col>
                                                        <v-container fluid class="pa-0">
                                                            <v-row justify="end" dense>
                                                                <v-col cols="12">
                                                                    <v-select
                                                                        v-model="customer.productionFileCustomerConfiguration"
                                                                        :items="productionFileCustomerConfigurations"
                                                                        label="Wybierz flow"
                                                                        item-value="id"
                                                                        item-text="templateJob"
                                                                        return-object
                                                                        outlined
                                                                        dense
                                                                        hide-details
                                                                        clearable
                                                                        @change="changeProductionFileCustomerConfiguration()"
                                                                    />
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </v-col>
                                                </v-row>
                                            </v-toolbar>
                                            <v-divider />
                                            <v-card-text>
                                                <v-row v-if="customer.productionFileCustomerConfiguration">
                                                    <v-col cols="12" lg="4">
                                                        <template>
                                                            <h3>Nazwa:</h3>
                                                            <span>
                                                                {{ customer.productionFileCustomerConfiguration.templateJob }}
                                                            </span>
                                                        </template>
                                                    </v-col>
                                                    <v-col cols="12" lg="4">
                                                        <template>
                                                            <h3>Grupa:</h3>
                                                            <span>
                                                                {{ customer.productionFileCustomerConfiguration.jobGroup }}
                                                            </span>
                                                        </template>
                                                    </v-col>
                                                    <v-col cols="12" lg="4">
                                                        <template>
                                                            <h3>Akronim:</h3>
                                                            <span>
                                                                {{ customer.productionFileCustomerConfiguration.acronym }}
                                                            </span>
                                                        </template>
                                                    </v-col>
                                                </v-row>
                                                <v-alert
                                                    v-else
                                                    type="info"
                                                    text
                                                    border="left"
                                                    class="ma-0"
                                                >
                                                    Brak flow dla klienta.
                                                </v-alert>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="success"
                                medium
                                data-sentry-label="Zapisz"
                                :loading="actionLoading"
                                @click="saveCustomer"
                            >
                                Zapisz
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'

import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { isEmpty } from 'lodash'

import CustomerContactDialog from './CustomerContactDialog'
import CustomerAddressDialog from './CustomerAddressDialog'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import PageTitle from '@/components/common/PageTitle'

import { errorHandler } from '@/utils/errorHandler'

import customFilters from '@/mixins/customFilters'
import parse from '@/mixins/parse'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'Customer',
    directives: { mask },
    components: {
        PageTitle,
        CustomerContactDialog,
        CustomerAddressDialog,
        ConfirmDialog,
    },
    mixins: [ customFilters, parse, pagination, tooltipDelay ],
    beforeRouteEnter(to, from, next) {
        // Edycja klienta
        if (typeof to.params.id !== 'undefined') {
            store.dispatch('customers/getCustomer', to.params.id)
                .then(response => {
                    Promise.all([
                        store.dispatch('customers/getCustomerTypes'),
                        store.dispatch('customers/getCountries'),
                        store.dispatch('customers/getAddressTypes'),
                        store.dispatch('customers/getProductionFileCustomerConfiguration')
                    ])
                        .then(() => {
                            next(vm => {
                                vm.actionName = 'updateCustomer'
                                vm.customer = Object.assign({}, response.data)
                                vm.isActive = !vm.customer.isHidden
                                vm.pageTitle = to.meta.title
                                vm.indexedCustomerAddresses()
                            })
                        })
                        .catch(error => {
                            next(error)
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        // Tworzenie klienta
        } else {
            Promise.all([
                store.dispatch('customers/getCustomerTypes'),
                store.dispatch('customers/getCountries'),
                store.dispatch('customers/getAddressTypes'),
                store.dispatch('customers/getProductionFileCustomerConfiguration')
            ])
                .then(() => {
                    next(vm => {
                        vm.actionName = 'createCustomer'
                        vm.pageTitle = to.meta.title
                    })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        }
    },
    data() {
        return {
            pageTitle: null,
            customer: {
                name: null,
                nip: null,
                isHidden:false,
                customerTypeId: null,
                customerAddresses: [],
                productionFileCustomerConfiguration: null
            },
            isActive: false,
            openedCustomerAddressesPanels: [],
            currentCustomerContact: {},
            customerContactDialog: false,
            confirmRemoveCustomerContactDialog: false,
            currentCustomerAddress: {},
            openedContactsPanels: [],
            customerAddressDialog: false,
            confirmRemoveCustomerAddressDialog: false,
            actionLoading: false,
            actionName: null,
        }
    },
    computed: {
        hasContacts() {
            let hasContacts = false

            if (this.customer.customerAddresses.length > 0) {
                hasContacts = this.customer.customerAddresses.some(contact => contact.addresses.length > 0)
            }

            return hasContacts
        },
        hasAddresses() {
            return this.customer.customerAddresses.length > 0
        },
        customerTypes() {
            return this.$store.state.customers.customers.customerTypes
        },
        productionFileCustomerConfigurations() {
            return this.$store.state.customers.customers.productionFileCustomerConfiguration
        },
        nameErrors() {
            const errors = []

            if (!this.$v.customer.name.$dirty) return errors
            !this.$v.customer.name.required && errors.push('Proszę podać nazwę firmy.')

            return errors
        },
        nipErrors() {
            const errors = []

            if (!this.$v.customer.nip.$dirty) return errors
            !this.$v.customer.nip.required && errors.push('Proszę podać nip.')

            return errors
        },
        customerTypeIdErrors() {
            const errors = []

            if (!this.$v.customer.customerTypeId.$dirty) return errors
            !this.$v.customer.customerTypeId.required && errors.push('Proszę podać typ klienta.')

            return errors
        },
        isCustomerActive() {
            return !this.customer.isHidden
        }
    },
    validations() {
        return {
            customer: {
                name: {
                    required
                },
                nip: {
                    required
                },
                customerTypeId: {
                    required
                },
            }
        }
    },
    methods: {
        parseAddress(address) {
            return address.companyName
                ? `${address.companyName}, ${address.street}, ${address.postCode} ${address.city} ${address.country.name} (${address.addressType.name}) - kolejność: ${address.order}`
                : `${address.street}, ${address.postCode} ${address.city } ${address.country.name} (${address.addressType.name}) - kolejność: ${address.order}`
        },
        parseContact(contact) {
            return `${contact.firstName} ${contact.lastName}, ${contact.phoneNumber}, ${contact.email}`
        },
        changeProductionFileCustomerConfiguration() {
            !isEmpty(this.customer.productionFileCustomerConfiguration)
                ? this.customer.productionFileCustomerConfigurationId = this.customer.productionFileCustomerConfiguration.id
                : this.customer.productionFileCustomerConfigurationId = null
        },
        parseValue(value) {
            return !value ? '-' : value
        },
        changeCustomerName(value) {
            this.customer.name = this.parseEmptyStringToNull(value)
        },
        changeCustomerNip(value) {
            this.customer.nip = this.parseEmptyStringToNull(value)
        },
        indexedCustomerContacts(address) {
            address.contacts.forEach(item => {
                delete item.addressIndex
            })
            address.contacts = address.contacts.map((item, contactIndex) => ({
                contactIndex,
                ...item
            }))
        },
        showConfirmRemoveCustomerContactDialog(contactIndex, customerAddressIndex) {
            this.currentCustomerAddress = this.customer.customerAddresses[customerAddressIndex]
            const index = this.currentCustomerAddress.contacts.findIndex(item => item.contactIndex === contactIndex)

            this.currentCustomerContact = this.currentCustomerAddress.contacts[index]
            this.confirmRemoveCustomerContactDialog = true
        },
        removeCustomerContact() {
            const contactIndex = this.currentCustomerAddress.contacts.findIndex(item => item.contactIndex === this.currentCustomerContact.contactIndex)

            this.currentCustomerAddress.contacts.splice(contactIndex, 1)
            this.indexedCustomerContacts(this.currentCustomerAddress)
            this.closeConfirmRemoveCustomerContactDialog()
        },
        closeConfirmRemoveCustomerContactDialog() {
            this.confirmRemoveCustomerContactDialog = false

            setTimeout(() => {
                this.currentCustomerContact = {}
            }, 500)
        },
        showCreateCustomerContactDialog(customerAddressIndex) {
            this.currentCustomerAddress = this.customer.customerAddresses[customerAddressIndex]
            this.customerContactDialog = true
        },
        showEditCustomerContactDialog(customerContactIndex, customerAddressIndex) {
            this.currentCustomerAddress = this.customer.customerAddresses[customerAddressIndex]
            const index = this.currentCustomerAddress.contacts.findIndex(item => item.contactIndex === customerContactIndex)

            this.currentCustomerContact = this.currentCustomerAddress.contacts[index]
            this.customerContactDialog = true
        },
        saveCustomerContact(customerContact) {
            const currentAddressIndex = this.currentCustomerAddress.addressIndex

            const index = this.customer.customerAddresses[currentAddressIndex].contacts.findIndex(item => item.contactIndex === customerContact.contactIndex)

            if (index >= 0) {
                this.customer.customerAddresses[currentAddressIndex].contacts.splice(index, 1, customerContact)
            } else {
                this.customer.customerAddresses[currentAddressIndex].contacts.push(customerContact)
                this.indexedCustomerContacts(this.currentCustomerAddress)
            }
        },
        closeCustomerContactDialog() {
            this.customerContactDialog = false

            setTimeout(() => {
                this.currentCustomerContact = {}
                this.currentCustomerAddress = {}
            }, 500)
        },
        indexedCustomerAddresses() {
            this.customer.customerAddresses.forEach(item => {
                delete item.contactIndex
            })
            this.customer.customerAddresses = this.customer.customerAddresses.map((item, addressIndex) => ({
                addressIndex,
                ...item,
            }))
            this.customer.customerAddresses.forEach(item => this.indexedCustomerContacts(item))
        },
        showConfirmRemoveCustomerAddressDialog(event, customerAddress) {
            event.cancelBubble = true
            const index = this.customer.customerAddresses.findIndex(item => item.addressIndex === customerAddress.addressIndex)

            this.currentCustomerAddress = this.customer.customerAddresses[index]
            this.confirmRemoveCustomerAddressDialog = true
        },
        removeCustomerAddress() {
            const addressIndex = this.customer.customerAddresses.findIndex(item => item.addressIndex === this.currentCustomerAddress.addressIndex)

            this.customer.customerAddresses.splice(addressIndex, 1)

            this.indexedCustomerAddresses()
            this.closeConfirmRemoveCustomerAddressDialog()
        },
        closeConfirmRemoveCustomerAddressDialog() {
            this.confirmRemoveCustomerAddressDialog = false

            setTimeout(() => {
                this.currentCustomerAddress = {}
            }, 500)
        },
        showCreateCustomerAddressDialog() {
            this.customerAddressDialog = true
        },
        showEditCustomerAddressDialog(event, customerAddress) {
            event.cancelBubble = true
            const index = this.customer.customerAddresses.findIndex(item => item.addressIndex === customerAddress.addressIndex)

            this.currentCustomerAddress = this.customer.customerAddresses[index]
            this.customerAddressDialog = true
        },
        saveCustomerAddress(customerAddress) {
            const index = this.customer.customerAddresses.findIndex(item => item.addressIndex === customerAddress.addressIndex)

            if (index >= 0) {
                this.customer.customerAddresses.splice(index, 1, customerAddress)
            } else {
                this.customer.customerAddresses.push(customerAddress)
                this.indexedCustomerAddresses()
            }
        },
        closeCustomerAddressDialog() {
            this.customerAddressDialog = false

            setTimeout(() => {
                this.currentCustomerAddress = {}
            }, 500)
        },
        saveCustomer() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true
            this.$store.dispatch(`customers/${this.actionName}`, this.customer)
                .then(() => {
                    this.onClose()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        onClose() {
            this.$router.push({ name: 'customersCustomers' })
                .catch(error => {
                    errorHandler(error)
                })
        },
        changeActive(isActive) {
            this.customer.isHidden = !isActive
        }
    }
}
</script>